import { map, isEmpty, toLower, escapeRegExp } from "lodash"

const GROUP_TITLES = {
  model: "Risk Model",
  forecast: "Forecasts",
  factorSensitivity: "Factor Sensitivity",
  proprietary: "Proprietary",
  licensed: "Licensed",
}

export const MENU_ITEMS_GROUPS = {
  layout: {
    groupId: "layout",
    groupLabel: "Layout",
  },
}

export function getHighlightedText(text, highlight) {
  // Split on highlight term and include term into parts, ignore case
  if (isEmpty(highlight)) { return text }

  const parts = text.split(new RegExp(`(${escapeRegExp(highlight)})`, "gi"))

  // [TODO] [#184018795] JSX shouldn't be in selectors or models
  return <span>
    {map(parts, (part, i) =>
      <span key={i} style={toLower(part) === toLower(highlight) ? { fontWeight: "bold" } : {}}>
        {part}
      </span>)}
  </span>
}

export function getGroup({ type = "model", proprietary }) {
  let groupId = type
  if (type === "contentset") {
    groupId = proprietary ? "proprietary" : "licensed"
  }

  if (!GROUP_TITLES[groupId]) {
    return {
      groupId: null,
      groupLabel: null,
    }
  }
  return {
    groupId,
    groupLabel: GROUP_TITLES[groupId],
  }
}

export function menuContentSets(contentSets) {
  return map(contentSets, (contentSet) =>
    ({
      ...contentSet,
      isContentSet: true,
      type: "contentset",
      tooltip: contentSet.description,
      path: `contentset/${contentSet.id}`,
    }))
}
